import React from 'react'
import { FlatList, FlatListProps, StyleSheet } from 'react-native'

import { Color, Spacing } from '../../style'
import { Banner } from '../feedback'
import { Text } from '../typography'

const styles = StyleSheet.create({
  empty: {
    textAlign: 'center',
    margin: Spacing.M,
    color: Color.calmGrey,
  },
  error: {
    margin: Spacing.S,
  },
})

export interface Props<T = any> extends FlatListProps<T> {
  empty?: string | false
  error?: string | false
}

const List = (props: Props) => {
  const { renderItem, empty, error, data, ...otherProps } = props
  const showEmpty = empty && data?.length === 0
  const renderEmpty = () => (showEmpty ? <Text style={styles.empty}>{empty}</Text> : undefined)

  const renderError = () => (error ? <Banner message={error} status="error" style={styles.error} /> : undefined)

  return (
    <FlatList
      renderItem={renderItem}
      ListHeaderComponent={renderError()}
      ListEmptyComponent={renderEmpty()}
      data={data}
      keyboardShouldPersistTaps="always"
      {...otherProps}
    />
  )
}

export default List
